<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">
              {{ $t("landing.titre") }}
            </h1>
            <h4>
              {{ $t("landing.sous-titre") }}
            </h4>
            <br />
            <md-button
              href="https://youtu.be/nvBc-TLV-2A"
              target="_blank"
              class="md-success md-l"
              ><i class="fas fa-play"></i>
              {{ $t("landing.btn-marche") }}</md-button
            >
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item  md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center">{{ $t("landing.titre2") }}</h2>
              <h5 class="description">
                {{ $t("landing.description") }}
              </h5>
            </div>
          </div>
        </div>
        <services></services>
      </div>

      <pays></pays>

      <temoignage></temoignage>

      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">{{ $t("landing.aide") }}</h2>
              <h4 class="text-center description">
                {{ $t("landing.details") }}
              </h4>
              <formulaire></formulaire>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from "./myComponents/accueilService";
import temoignage from "@/views/myComponents/temoignage";
import formulaire from "@/views/myComponents/formulaire";
import pays from "@/views/myComponents/pays";
export default {
  bodyClass: "landing-page",
  components: {
    pays,
    formulaire,
    temoignage,
    services
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/student.png")
    },
    pays1: {
      type: String,
      default: require("@/assets/img/canada.jpeg")
    },
    pays2: {
      type: String,
      default: require("@/assets/img/france.jpeg")
    },
    pays3: {
      type: String,
      default: require("@/assets/img/usa.jpeg")
    },
    pays4: {
      type: String,
      default: require("@/assets/img/turkie.jpeg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
        backgroundColor: '#efbc65',
        backgroundPosition: 'right',
        backgroundSize: '32%',
        backgroundRepeat: 'no-repeat'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
